import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { SyncBatchDetailPage } from '@features/admin/sync-batches';
import { useAdminSyncBatchStore } from '@features/admin/sync-batches/useAdminSyncBatchStore.ts';

const paramsSchema = z.object({
  requestId: z.string().uuid(),
});

const searchSchema = z.object({
  product: z.string().optional(),
  supplier: z.string().optional(),
  client: z.string().optional(),
  portalSourceId: z.coerce.number().optional(),
  priceFrom: z.coerce.number().optional(),
  priceTo: z.coerce.number().optional(),
  // Proklik z upozornění nad tabulkou na konkrétní neúplné řádky.
  issue: z.enum(['NO_VARIANT', 'NO_VISIBILITY', 'NOT_IN_DB', 'ORG_UNRESOLVED']).optional(),
  sortBy: z.enum(['PRICE_SOURCE_ID', 'PRODUCT', 'SUPPLIER', 'CLIENT', 'PRICE']).optional().default('PRICE_SOURCE_ID'),
  sortDir: z.enum(['ASC', 'DESC']).optional().default('ASC'),
  page: z.coerce.number().optional().default(1),
  // Payload dávky se rozbaluje při každém dotazu, takže větší stránka = míň průchodů.
  size: z.coerce.number().optional().default(50),
});

export type AdminSyncBatchDetailSearch = z.infer<typeof searchSchema>;

export const Route = createFileRoute('/admin/sync-batches/$requestId')({
  params: { parse: v => paramsSchema.parse(v) },
  validateSearch: search => searchSchema.parse(search),
  component: RouteComponent,
  beforeLoad: ctx => {
    const { requestId } = paramsSchema.parse(ctx.params);
    const { product, supplier, client, portalSourceId, priceFrom, priceTo, issue, sortBy, sortDir, page, size } = ctx.search;
    useAdminSyncBatchStore.getState().loadBatchDetail({
      requestId,
      product,
      supplier,
      client,
      portalSourceId,
      priceFrom,
      priceTo,
      issue,
      sortBy,
      sortDir,
      page: page || 1,
      size: size || 50,
    });
  },
});

function RouteComponent() {
  return <SyncBatchDetailPage />;
}
